var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0126 2.51256C11.696 1.82915 12.804 1.82915 13.4875 2.51256C14.1709 3.19598 14.1709 4.30402 13.4875 4.98744L6.22604 12.2489C5.97066 12.5042 5.66748 12.7068 5.33382 12.845L3.28702 13.6928C3.00676 13.8088 2.68417 13.7447 2.46968 13.5302C2.25519 13.3157 2.19103 12.9931 2.30712 12.7128L3.15488 10.6663C3.29308 10.3327 3.49563 10.0295 3.75098 9.77417L11.0126 2.51256Z",
    fill: "#4A304A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAcc);
export default __webpack_public_path__ + "static/media/pencil_acc.4755afbd704b890be996b9c593a7e02c.svg";
export { ForwardRef as ReactComponent };